import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useTranslation } from 'react-i18next'
import AddStatusForm from './AddStatusForm'

/**
 * Changing a parcel's status without leaving the list.
 *
 * The status column is where someone notices a parcel is on the wrong one, and opening the whole
 * parcel to fix it was the long way round. This is the same form the parcel page shows, so the
 * options on offer, the reason code and the consumer's notification behave identically — and
 * someone who may not add a status gets a dialog with nothing to submit rather than a button that
 * fails.
 */
export default function ChangeStatusDialog({
  parcel,
  open,
  onClose,
  onChanged,
}) {
  const { t } = useTranslation('parcels')

  if (!parcel) return null

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pr: 6 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography variant="h6" component="span">
            {t('changeStatus')}
          </Typography>
          <Typography variant="body2" color="text.secondary" component="span">
            {parcel.parcelId}
          </Typography>
        </Stack>
        <IconButton
          aria-label={t('close')}
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <AddStatusForm parcel={parcel} onChanged={onChanged} />
      </DialogContent>
    </Dialog>
  )
}
